import CustomModalLayout from "./CustomModalLayout";
import React, { SetStateAction, useState, useEffect } from "react";
import { Button } from "../../../shadcn/components/ui/button";
import { OTPInputComponent } from "../Auth/OTPInputComponent";
import { BetaForm as useBetaForm } from "@reusejs/react";
import { useSelector, useDispatch } from "react-redux";
import {
  requestMobileVerification,
  verifyMobileRegistration,
  updateUser,
  getUser,
  checkAndUpdateBidder,
  intiateMobileLoginWithOtp,
  mobileLoginWithOtp,
  emailLoginWithOtp,
  intiateEmailLoginWithOtp,
  getBidderOnboardingOfUser,
} from "services";
import {
  setTempToken,
  setTokens,
  setUser,
  clearTempToken,
  clearGuestUser,
  setBidderUser,
  setBidderOnboarding,
  setOnboarding,
} from "store";
import { useRouter } from "next/router";
import {
  createBidderOnboardingWithOutData,
  createZohoLeadWithData,
} from "services/bidder";
interface props {
  userLoggedin: boolean;
  inputModelOpen: boolean;
  registerModelOpen?: boolean;
  action: string;
  setLoginModalOpen: React.Dispatch<SetStateAction<boolean>>;
  setInputModalOpen: React.Dispatch<SetStateAction<boolean>>;
}

function OTPInputModal({
  userLoggedin,
  inputModelOpen,
  action,
  setLoginModalOpen,
  setInputModalOpen,
}: props) {
  const router = useRouter();
  const dispatch = useDispatch();

  let guestUser = useSelector((state: any) => {
    return state.auth.guestUser;
  });
  const redirectUrl = useSelector((state: any) => {
    return state.auth.redirectUrl;
  });
  const [timer, setTimer] = useState(60);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const form_constraints = {
    user_identity: {
      presence: {
        allowEmpty: false,
      },
    },
    token: {
      presence: {
        allowEmpty: false,
        message: "^OTP can't be blank",
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const form = useBetaForm({
    user_identity: "",
    token: "",
  });

  useEffect(() => {
    let countdown: NodeJS.Timeout | null = null;

    if (timer > 0) {
      setIsButtonDisabled(true);
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setIsButtonDisabled(false);
    }

    return () => {
      if (countdown) clearInterval(countdown);
    };
  }, [timer]);

  const handleVerification = async () => {
    try {
      setLoading(true);
      if (form.validate()) {
        if (action === "verifyRegistration") {
          await verifyMobileRegistration(form).then(async (res: any) => {
            // dispatch(setTempToken(res));
            dispatch(setTokens({ access_token: res.access_token }));

            await updateUser({
              bio: {
                full_name: guestUser.name ? guestUser.name : "",
              },
            });

            await fetch("/api/login", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                accessToken: { access_token: res.access_token },
              }),
            });

            const user: any = await getUser();
            const userEmail = user?.attributes.find(
              (attr: any) => attr.type === "email",
            )?.value;
            try {
              await createZohoLeadWithData({
                data: [
                  {
                    Last_Name: guestUser.name ? guestUser.name : "",
                    Email: guestUser.isEmail ? guestUser.user_identity : "NA",
                    Mobile: !guestUser.isEmail ? guestUser.user_identity : "NA",
                  },
                ],
              });
            } catch (error) {
              console.log("Zoho Lead Creation Error: ", error);
            }
            if (userEmail) {
              await checkAndUpdateBidder(userEmail, user.uuid);
            }
            const onboardingData: any = await getBidderOnboardingOfUser(
              user.uuid,
            );
            dispatch(setUser(user));
            dispatch(setBidderUser(user));
            dispatch(clearTempToken());
            dispatch(clearGuestUser());
            dispatch(setOnboarding(onboardingData));
            dispatch(setBidderOnboarding(onboardingData));
            setInputModalOpen(false);
            if (onboardingData && onboardingData.status === "active") {
              if (redirectUrl) {
                router.push(redirectUrl);
              } else {
                router.push("/");
              }
            } else if (onboardingData) {
              if (redirectUrl) {
                router.push(redirectUrl);
              } else {
                router.push("/dashboard/profile");
              }
            } else {
              const payload: any = {
                user_uuid: user.uuid,
              };

              if (user?.profile?.bio?.full_name) {
                payload["name"] = user.profile.bio.full_name;
                // payload["authorized_person_name"] =
                //   user.profile.bio.full_name;
              }
              const res: any = await createBidderOnboardingWithOutData(payload);
              dispatch(setOnboarding(res));
              dispatch(setBidderOnboarding(res));
              if (redirectUrl) {
                router.push(redirectUrl);
              } else {
                router.push("/dashboard/profile");
              }
            }

            //   if (redirectUrl) {
            //   router.push(redirectUrl);
            // }
            // if (user?.attributes.length !== 2) {
            //   router.push("/dashboard/profile");
            // } else {
            //   router.push("/");
            // }
          });
        } else if (action === "verifyLogin") {
          if (guestUser?.isEmail) {
            await emailLoginWithOtp(form).then(async (res: any) => {
              await handleAfterLogin(res);
            });
          } else {
            await mobileLoginWithOtp(form).then(async (res: any) => {
              await handleAfterLogin(res);
            });
          }
        }
      }
    } catch (error: any) {
      setLoading(false);
      console.log("check here error", error);
    }
    setLoading(false);
  };

  const handleAfterLogin = async (res: any) => {
    dispatch(setTokens({ access_token: res.access_token }));

    await fetch("/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        accessToken: { access_token: res.access_token },
      }),
    });

    const user: any = await getUser();
    const userEmail = user?.attributes.find(
      (attr: any) => attr.type === "email",
    )?.value;

    if (userEmail) {
      await checkAndUpdateBidder(userEmail, user.uuid);
    }

    const onboardingData: any = await getBidderOnboardingOfUser(user.uuid);

    if (redirectUrl) {
      router.push(redirectUrl);
    } else {
      if (onboardingData && onboardingData.status === "active") {
        router.push("/");
      } else {
        router.push("/dashboard/profile");
      }

      // if (user?.attributes.length !== 2) {
      //   router.push("/dashboard/profile");
      // } else {
      //   router.push("/");
      // }
    }
    dispatch(setUser(user));
    dispatch(setBidderUser(user));
    dispatch(clearTempToken());
    dispatch(clearGuestUser());
    dispatch(setOnboarding(onboardingData));
    dispatch(setBidderOnboarding(onboardingData));
    setInputModalOpen(false);
  };

  const handleResendOTP = async () => {
    try {
      setTimer(60); // Reset timer back to 20 seconds
      setIsButtonDisabled(true); // Disable buttons after resending
      if (action === "verifyRegistration") {
        await requestMobileVerification(form);
      } else if (action === "verifyLogin") {
        // login request
        if (guestUser?.isEmail) {
          intiateEmailLoginWithOtp(form);
        } else {
          await intiateMobileLoginWithOtp(form);
        }
      }
    } catch (error) {
      console.log("check here error", error);
    }
  };

  useEffect(() => {
    form.setField("user_identity", guestUser?.user_identity);
    form.setField("token", "");
    form.removeError("token");
  }, [guestUser?.user_identity]);

  return (
    <CustomModalLayout
      open={inputModelOpen}
      className={`pt-8 pb-[30px] ${!userLoggedin ? "min-h-[583px]" : ""}  `}
      childrenClassName="pl-4 pr-6"
      onClose={() => setInputModalOpen(false)}
    >
      <div className="h-full flex flex-col flex-grow">
        <div>
          <p
            className={`font-openSans font-semibold ${
              userLoggedin ? "text-center" : ""
            } text-[24px] leading-8 text-black `}
          >
            {guestUser?.isEmail ? "Verify your email" : "Verify your number"}
          </p>
          {action === "verifyLogin" ? (
            <div className="flex space-x-2 mt-[45px] items-center">
              <p className="font-openSans font-normal text-web-body-lg leading-[22px] text-brand-textGrey">
                OTP sent to your registered credentials
              </p>
              <button
                className="underline"
                onClick={() => {
                  setInputModalOpen(false);
                  setLoginModalOpen(true);
                }}
              >
                Back
              </button>
            </div>
          ) : (
            <div className="flex space-x-2 mt-[45px]">
              <p className="font-openSans font-normal text-web-body-lg leading-[22px] text-brand-textGrey">
                OTP sent to{" "}
                <strong className="font-semibold">
                  {form.value.user_identity}
                </strong>
              </p>
              <button
                className="underline"
                onClick={() => {
                  setInputModalOpen(false);
                  setLoginModalOpen(true);
                }}
              >
                Edit
              </button>
            </div>
          )}

          <p className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-bgBlack mt-8">
            Verify OTP
          </p>
          <div className="w-full flex justify-center mt-2">
            <OTPInputComponent
              otpEntered={form.getField("token")}
              setOtpEntered={(v) => form.setField("token", v)}
              onSubmit={handleVerification}
            />
          </div>
          {form.errors.get("token") ? (
            <p className="mt-2 text-sm text-red-500">
              {form.errors.get("token")[0]}
            </p>
          ) : null}
          <div className="mt-7 flex items-center font-openSans font-normal text-web-body-sm leading-[18px] text-[#717272] space-x-2">
            <p className="">Didn’t get OTP? </p>
            {timer > 0 ? (
              <p>Resend OTP in {timer} sec</p>
            ) : (
              <button
                className="underline"
                onClick={handleResendOTP}
                disabled={isButtonDisabled}
              >
                Resend OTP
              </button>
            )}
          </div>
        </div>
        <Button
          className="w-full mt-auto mb-[60px]"
          disabled={loading}
          onClick={() => handleVerification()}
        >
          Next
        </Button>
      </div>
    </CustomModalLayout>
  );
}

export default OTPInputModal;
